import PageTitle from "../../Component/Page/PageTitle";
import Section from "../../Component/Layout/Section";
import { Heading, Image, Flex, Spacer, Box, Text, Center, Divider, Grid, GridItem, Link, Button, useMediaQuery } from "@chakra-ui/react";
import { responsiveValue } from "../../assets/style/defaultTheme";
import { theme } from "../../assets/style/theme";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";
import LineBreakOnDesktop from "../../Component/Br/LineBreakOnDesktop";
import { ContactSection } from "./style";
const { flexBoxDirection } = responsiveValue;

function AboutEn() {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
    <PageTitle
				type="big"
				bgPath="about/topbg.png"
				title="Korea Safety Health Environment Foundation"
				description="How many trees does it take to make a 'forest'? When you start sharing your shade, fragrance, seeds, and fruits -with other trees, people, and the wider world, it becomes a 'forest.' It becomes 'sharing."
			/>

    <Section pt={110}>
      <Heading as="h1" size="4xl" color="b.g" pb="10" id="about01">
        Core Values
      </Heading>
      <Flex>
        <Box h="200">
          <Image src="/images/about/value01.png" />
          <Text textAlign="center" fontSize={isMobile ? 12 : 24}fontWeight={700}>Public Accountability</Text>
        </Box>
        <Spacer />
        <Box>
          <Image src="/images/about/value02.png" />
          <Text textAlign="center" fontSize={isMobile ? 12 : 24}fontWeight={700}>Transparency</Text>
        </Box>
        <Spacer />
        <Box>
          <Image src="/images/about/value03.png" />
          <Text textAlign="center" fontSize={isMobile ? 12 : 24}fontWeight={700}>Expertise</Text>
        </Box>
        <Spacer />
        <Box>
          <Image src="/images/about/value04.png" />
          <Text textAlign="center" fontSize={isMobile ? 12 : 24}fontWeight={700}>Independence</Text>
        </Box>
      </Flex>
    </Section>

    <Section>
				<Heading as="h1" size="4xl" color="b.g" pb="10">
					Ideal Talents
				</Heading>
				<Flex direction={flexBoxDirection} alignItems="center" >
					<Box maxW="sm" pb={isMobile ? 10 : 0}>
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp01.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
                Talents individuals with a science-based mindset
								</Heading>								
							</Box>
						</Flex>
					</Box>
					<Spacer />
					<Box maxW="sm">
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp02.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
                Talents individuals who believe in the power of collaboration
								</Heading>
							</Box>
						</Flex>
					</Box>
					<Spacer />
					<Box maxW="sm">
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp03.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
                Talents individuals who respect public values
								</Heading>								
							</Box>
						</Flex>
					</Box>
				</Flex>
			</Section>

      <Section>
				<Heading as="h1" size="5xl" color="b.bk" pb="10" id="about02">
        Greetings
				</Heading>
				<Flex direction={flexBoxDirection} justifyContent="space-between" alignItems="start">
					<Text maxW="640" fontSize={isMobile ? "16px" : "16px"}>
            Thank you for visiting the Korea SHE Foundation.
            <br/><br/>
            Korea SHE foundation  is a non-profit organization established with the aspiration that the future of our homes, workplaces, and local communities should be safer, healthier, and more sustainable, amidst growing concerns about degradation and increasing risks in our society. 
            <br/><br/>
            Our mission is to cultivate future leaders who will play a proactive role, and to develop and disseminate alternatives by engaging in dialogue and sharing wisdom with various stakeholders in society.
            <br/><br/>
            Just as a healthy forest thrives through the mutual sharing and symbiosis of all its inhabitants, so too does wisdom and happiness grow as they are shared. This universal truth is something that nobody can deny.
            <br/><br/>
            Korea SHE foundation adheres to the virtues of the 'forest' and believes in the power of 'sharing'. We are committed to making our future as healthy, safe, and sustainable as a forest by putting these principles into practice. We kindly ask for your support, encouragement, and participation.
            <br/><br/>
            Thank you.

            <br/><br/><br/>
            Chairperson of the Korea SHE foundation.
						<Image src="/images/about/sign_en.png" maxW="290" pt="6" />
					</Text>
					<Image src="/images/about/ceo.png" maxW={isMobile ? "300" : "488"} h="auto" flexShrink={0} mt={isMobile ? "10" : "0"} />
				</Flex>
			</Section>

      <PageTitle type="small" bgPath="about/bizbg.png" title="Our Work" description="The Korea SHE foundation is a non-profit organization dedicated to fostering talents in the fields of environment, safety, and health to create a safe and healthy society." />

      <Section pt={80}>
				<Heading as="h1" size="4xl" color="b.g" pb="10" id="about03">
					Areas of Focus
				</Heading>

				<Flex justify="space-around">
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate01.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
            Environment
						</Heading>
					</Box>
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate02.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
            Safety
						</Heading>
					</Box>
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate03.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
            Health
						</Heading>
					</Box>
				</Flex>

				<Text fontSize="lg" pt="14" lineHeight="2">
        "It would seem that whenever there is a rapid change in society, it is the EHS that is most vulnerable and threatened.
				<br/>
				Despite the importance of this field, there is a significant shortage of qualified human resources, which has resulted in a weakness in the expertise and problem-solving capacities of our society. In order to overcome these limitations, it would be beneficial to develop human resources to solve challenges in the field of EHS and build social capacities to develop rational problem-solving alternatives and discourse. It would also be advantageous to develop the ability to make various interest groups cooperate and communicate with each other.
				<br/>
				The Korea SHE Foundation was established with the aspiration that our domestic, occupational and local environments should be as healthy, safe and sustainable as forests. Forest & Share places great value on the concept of the 'forest' and the power of 'sharing'. We will endeavour to cultivate human resources capable of assuming a pioneering role in the field of environment, safety, and health. Furthermore, we will strive to cultivate and disseminate rational problem-solving alternatives, discourse, and a spirit of cooperation and communication with members of our diverse society."
				</Text>
			</Section>

      <Section>
				<Heading as="h1" size="5xl" pb="8" id="about05">
        Board of Directors
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" pb="20" lineHeight="1.5">
        Korea SHE foundation is operated by a board of directors and committees composed of professionals with expertise in various fields, ensuring transparency and fairness.
				</Heading>

        {/* <Text textAlign="center" fontSize="28" fontWeight="700" mb="12">‌Board of trustees</Text> */}
				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6} rowGap={10}>
					<GridItem>
						<Image src="/images/about/p01.png" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              Chairman of<br/>the KoreaSHE Foundation
							</Text>
							<Heading size="xl">Jaeyeon Jang
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
            -Honorary Professor at Ajou University<br/>
						-Co-Representative of the Korea Federation for Environmental Movements (2012-2020)
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p02.png" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              ‌Members of the board

							</Text>
							<Heading size="xl">Dowan Ku
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
            -Director of the Institute for Environmental and Social Research
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p03.png" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              ‌‌Members of the board

							</Text>
							<Heading size="xl">Hocheol Kim
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
            -Attorney at Hankyul Law Firm<br/>
						-Chairman of the National Police Commission

						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p04.png" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              ‌‌Members of the board

							</Text>
							<Heading size="xl">‌Yvonne Park
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
						- CEO of FleishmanHillard Korea
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p05.jpg" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              ‌‌Members of the board
							</Text>
							<Heading size="xl">Yoon Je-yong
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
						-Professor, College of Engineering, Seoul National University
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p06.png" />
						<Flex pt="4" justifyContent="space-between">
							<Text fontSize="md" paddingRight="2">
              Audit
							</Text>
							<Heading size="xl">‌Sangcheol Park
              </Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
            -CEO of Park Sang-chul Tax Accounting Office<br/>
						-Certified Public Accountant
						</Text>
					</GridItem>
				</Grid>
			</Section>   

			<Section>
				<Heading as="h1" size="5xl" pb="10">
				Main Programs
				</Heading>

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="4xl" color="b.gr">
						Research Talent Development support Program
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
							Research Talent<br/>Development
							</Heading>
							<Text w={isMobile ? "100%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/01/01">Master's and Doctoral Scholarship support Program</Link>
								<br />
								<br />
								<Link href="/en/global-leadership/">Global Leadership Scholarship Program</Link>
								<br />
								<br />
								<Link href="/participation/01/03">Postdoctoral Research Fellowship Program</Link>
								<br />
								<br />
								<Link href="/participation/01/04">Targeted Research Support Program</Link>
							</Text>
						</Flex>
						<Divider color="b.lg" mt="6" mb="6" />
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
							Civic Society Talent<br/> Development Program
							</Heading>
							<Text w="60%" fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/02/01">Scholarship for Dedicated Activists</Link>
								<br />
								<br />
								<Link href="/participation/02/02">Seed Academy</Link>
								<br />
								<br />
								<Link href="/participation/02/03">Flower Academy</Link>
								<br />
								<br />
								<Link href="/participation/02/04">Citizen Science Seed Grant</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="4xl" color="b.gr">
						Alternative Solution Development
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
							Citizen Idea<br/> Support Program
							</Heading>
							<Text w={isMobile ? "100%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/03/01">Citizen Idea Grant 'Seed'</Link>
								<br />
								<br />
								<Link href="/participation/03/02">Citizen Start-Up Grant 'Flower'</Link>
								<br />
								<br />
								<Link href="/participation/03/03">Citizen Challenge Grant 'Forest'</Link>
								<br />
								<br />
								<Link href="/en/global-seed-grant/">
								Global Seed Grant
								</Link>
								<br />
								<br />
								<Link href="/participation/03/05">Better Environment Project for Future Generations - Green Fruit Project</Link>
							</Text>
						</Flex>
						<Divider color="b.lg" mt="6" mb="6" />
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
							Green Agora
							</Heading>
							<Text w={isMobile ? "100%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/04/01">Life and Freedom Community Forum</Link>
								<br />
								<br />
								<Link href="/participation/04/02">Green Agora Forum</Link>
								<br />
								<br />
								<Link href="/participation/04/03">SHE's View</Link>
								<br />
								<br />
								<Link href="/participation/04/04">SHE Environmental Academic Forum</Link>
								<br />
								<br />
								<Link href="/participation/04/05">Seed Grant for Researchers' Workshop</Link>
								<br />
								<br />
								<Link href="/participation/04/06">Stump Publication Support for Retirees</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={6}>
						<Heading size="4xl" color="b.gr" lineHeight="1.5">
						Education, Cooperation, Culture,<br/>and Publishing Programs
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Education
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/05/01">Fine Dust Social Science Education Program</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Archive
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="https://ecoarchive.org/" isExternal>
								Environmental Archive Forest
								</Link>
								<br />
								<br />
								<Link href="https://ecophotoarchive.org/" isExternal>
								Environmental Photo Archive
								</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Publishing
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/05/05">Book Publishing</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Culture
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/05/02" isExternal>
								"Chris Jordan: Beyond Beauty" Exhibition
								</Link>
								<br />
								<br />
								<Link href="/participation/05/03">
								COVID-19 Photo Exhibition "The Art of Distance"
								</Link>
								<br />
								<br />
								<Link href="https://ecophotoarchive.org/exhibition/1" isExternal>
								4th Anniversary Exhibition "800 Returns Home"
								</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Cooperation
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/05/04">Emergency Support for Overcoming the COVID-19 Crisis</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={6}>
						<Heading size="4xl" color="b.gr" lineHeight="1.5">
						Institute of the Korea SHE Foundation
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Biodiversity<br/>Conservation Project
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
							Biodiversity Monitoring and Talent Development - ECOSEE<br/><br/>
							Nature Positive Campaign<br/><br/>
Freshwater Ecosystem Restoration Campaign
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
							Green Agora
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
							City for Living Forum<br/><br/>
Citizen Forum for Bicycles<br/><br/>
Forum for Life-Liberty-Community<br/><br/>
Korea Youth Eco Forum
							</Text>
						</Flex>
					</GridItem>
				</Grid>

			</Section>

      <Section>
        <Heading as="h3" size="4xl" color="b.dgr" pb="8">
				Address & Contact
          </Heading>
          <Text color="b.g" fontSize="xl">
            6th Floor, Geumjeong Building, 2606, Nambusunhwan-ro, Seocho-gu, Seoul, 06737, South Korea.
            <br/><br/>

            TEL : 02-6318-9000<br/>
            FAX : 02-6318-9100<br/>
            E-mail : <a href="mailto:koreashe@koreashe.org">koreashe@koreashe.org</a>
          </Text>
      </Section>
    </>
  )
}

export default AboutEn;
